import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as registerActions from './actions/';

class ThankYou extends Component {
    componentDidMount() {
        this.props.setStep('THANK_YOU');
    }

    render() {
        return (
            <div className="container-fluid wrapper">
                <div className="d-flex flex-column full-height menu-bar-bottom">
                    <div className="thank-you__container">
                        <div className="thank-you__icon">
                            <i className="material-icons">check_circle_outline</i>
                        </div>

                        <div className="thank-you__title">{window.VULOG_TRANSLATE('Thank You !')}</div>

                        <div className="thank-you__info">
                            <p>{window.VULOG_TRANSLATE('We are now processing your information')}</p>
                            <p>{window.VULOG_TRANSLATE('Your account will be validated in the next few minutes')}</p>
                        </div>
                    </div>

                    {/*<div className="d-flex flex-row mt-auto mb-1-5rem">*/}

                    {/*<button className="btn btn-primary btn-block ml-auto mr-auto">CLOSE</button>*/}

                    {/*</div>      */}
                </div>
            </div>
        );
    }
}

function mapStateToProps() {
    return {};
}
/**
 * Get actions and pass them as props to Component
 * @param dispatch
 * @returns {{}|B|N}
 */

function mapDispatchToProps(dispatch) {
    return bindActionCreators(registerActions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ThankYou);
